module.exports = __webpack_public_path__ + "img/13.8356d769.png";